import { Tooltip, Typography, useTheme } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { Chip } from '@shared/components';

export const NewFunctionalityChip = () => {
  const t = useAppTFunction();
  const theme = useTheme();
  return (
    <Tooltip title={t('common.newWarning')}>
      <Chip
        rounded
        size="small"
        sx={{ height: 18 }}
        label={
          <Typography color="common.white" variant="body3">
            {t('common.new')}
          </Typography>
        }
        backgroundColor={theme.vars.palette.primary.main}
      />
    </Tooltip>
  );
};
